"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var IntlProvider =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2["default"])(IntlProvider, _React$Component);

  function IntlProvider() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = IntlProvider.prototype;

  _proto.getChildContext = function getChildContext() {
    var locale = this.props.locale;
    return {
      rsuiteLocale: locale
    };
  };

  _proto.render = function render() {
    return this.props.children || null;
  };

  return IntlProvider;
}(React.Component);

(0, _defineProperty2["default"])(IntlProvider, "childContextTypes", {
  rsuiteLocale: _propTypes["default"].object
});
(0, _defineProperty2["default"])(IntlProvider, "handledProps", ["children", "locale"]);
var _default = IntlProvider;
exports["default"] = _default;